<div class="epi-container">
    <h4>Assigned Reps</h4>

    <!--[pageSize]="gridState.take"
    [skip]="gridState.skip"
    [pageable]="true"-->
    <div class="row" *ngIf="carrierRepsAssignedStats.length>0">
        <div class="col">
            <kendo-grid [data]="gridData"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [pageable]="false"
                        [sortable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        [autoSize]="false"
                        [selectable]="false"
                        (dataStateChange)="dataStateChange($event)">
                <kendo-grid-column field="employeeName" title="Carrier Rep" width="200"></kendo-grid-column>
                <kendo-grid-column field="assignedToday" title="Today"></kendo-grid-column>
                <kendo-grid-column field="assignedTomorrow" title="Tomorrow"></kendo-grid-column>
                <kendo-grid-column field="assignedBeyond" title="Beyond"></kendo-grid-column>
                <!--<kendo-grid-column field="isAssigned" title="Assigned">
                    <ng-template kendoGridCellTemplate let-rep>
                        <i *ngIf="rep.isAssigned!=true" class="far fa-square fa-lg text-secondary"></i>
                        <i *ngIf="rep.isAssigned==true" class="fas fa-check-square fa-lg text-primary"></i>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="emailAddress" title="Email">
                    <ng-template kendoGridCellTemplate let-rep>
                        <a href="mailto:{{rep.emailAddress}}" *ngIf="rep.emailAddress!=''&&rep.emailAddress!=null"><i class="fas fa-envelope fa-2x text-primary"></i></a>
                    </ng-template>
                </kendo-grid-column>-->
                <kendo-grid-column field="totalAssignedLoads" title="Total Assigned"></kendo-grid-column>
                <kendo-grid-column field="todaysHardContacts" title="HC Today"></kendo-grid-column>
                <kendo-grid-column field="awardedLoads" title="Awarded Loads"></kendo-grid-column>
                <kendo-grid-column field="awardedCanGets" title="Awarded CG"></kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>
